import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { PlanningTypes } from 'pages/admin/demand/planning/context/types/contextPrevision.type';
import api from 'services/api/api';

import { buildFiltersPayload } from '../utils/planningByLevelUtils';
interface UseIsPlanningCompleteProps {
	planningType: PlanningTypes;
	cycleId?: number | string;
	companyAreaId?: number | string;
}

export const getIsPlanningComplete = async ({
	planningType,
	cycleId,
	companyAreaId,
}: UseIsPlanningCompleteProps): Promise<boolean> => {
	const response = await api.get(`/${planningType}/is-complete`, {
		params: buildFiltersPayload({ cycleId, companyAreaId }),
	});
	return response.data;
};

export function useIsPlanningComplete({
	planningType,
	cycleId,
	companyAreaId,
}: UseIsPlanningCompleteProps): UseQueryResult<boolean, unknown> {
	const isCollaboration = planningType
		?.toLowerCase()
		.includes('collaboration');

	return useQuery({
		queryKey: ['is-complete', planningType, cycleId, companyAreaId],
		queryFn: async () => {
			return await getIsPlanningComplete({
				planningType,
				cycleId,
				companyAreaId,
			});
		},
		enabled:
			!!planningType &&
			!!cycleId &&
			(!isCollaboration || !!companyAreaId),
		staleTime: Infinity,
		retry: false,
		select: () => false,
		refetchOnWindowFocus: false,
	});
}
